export default "/assets/d1245bac538f2cfd.svg"